import { render, staticRenderFns } from "./BadgePreview.vue?vue&type=template&id=41bdab8e&"
import script from "./BadgePreview.vue?vue&type=script&lang=ts&"
export * from "./BadgePreview.vue?vue&type=script&lang=ts&"
import style0 from "./BadgePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
